import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-device-input-trigger',
  imports: [
    TranslateSafePipe,
  ],
  templateUrl: './device-input-trigger.html',
  styleUrls: [
    './device-input-trigger.css',
    '../base-rule-condtion.css'
  ],
})
export class DeviceInputTrigger {
  @Input({ required: true }) formGroup!: FormGroup;

}
